import { isNotEmpty, populateLinks } from '@techchange/pm-specs';
import { keymap } from 'prosemirror-keymap';

/**
 * Plugin that manages the submit listener.
 *
 * @param {Func} onSubmit  Callback function to trigger submission of the editor.
 * @param {Boolean} chatView  Flag specifying if chat view should be rendered.
 *
 * @returns {Object} Prosemirror Plugin object.
 */
const submitPlugin = (onSubmit, chatView) => {

	return keymap({
		Enter: (state, dispatch, editorView) => {

			let finalValue = editorView?.state?.doc?.toJSON();

			// Check if using the chat view
			if (chatView) {

				try {

					// Check to make sure the content is not empty
					if (!isNotEmpty(finalValue)) {
						finalValue = null;
					}

					// Auto-populate link marks
					finalValue = populateLinks(finalValue);

				} catch (error) {
					console.error(error);
				}

			}

			onSubmit(finalValue);

			return true;

		},
	});

};

export default submitPlugin;
